import { render, staticRenderFns } from "./TheInternalNotesBox.vue?vue&type=template&id=4daa4851&scoped=true"
import script from "./TheInternalNotesBox.vue?vue&type=script&lang=js"
export * from "./TheInternalNotesBox.vue?vue&type=script&lang=js"
import style0 from "./TheInternalNotesBox.vue?vue&type=style&index=0&id=4daa4851&prod&lang=css"
import style1 from "./TheInternalNotesBox.vue?vue&type=style&index=1&id=4daa4851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa4851",
  null
  
)

export default component.exports